import React, { ElementType, FC } from 'react'
import { Moment } from 'moment'
import { formatRelativeTime, IFormatRelativeTimeProps } from './utils'

interface IRelativeDateTimeProps extends IFormatRelativeTimeProps {
  dataTest?: string
  /**
   * Optionally pass a component in which the datetime value will be rendered
   * as a child.
   * @default 'span's
   */
  as?: ElementType
}

/**
 * Formats the given datetime as a relative time, using moment's fromNow
 * function.
 *
 * @returns '1 second ago'
 * @returns 'in 3 hours'
 * @returns '2 m ago' if shorthand
 */
export const RelativeDateTime: FC<IRelativeDateTimeProps> = ({
  as: Component = 'span',
  dataTest,
  datetime,
  endTime,
  inSentence = true,
  isShorthand = false,
}) => (
  <Component data-test={dataTest}>
    {formatRelativeTime({ datetime, endTime: endTime as Moment, inSentence, isShorthand })}
  </Component>
)

export default RelativeDateTime
